import { z } from "zod";
import { BrandCodeSchema } from "./mix";

export const PaletteInputSchema = z.object({
  id: z.string().optional(),
  paletteName: z.string(),
  colors: z.array(z.string()).nullable(),
  brandCode: BrandCodeSchema,
});

export type PaletteInputType = z.infer<typeof PaletteInputSchema>;

export const PaletteOutputSchema = z.object({
  id: z.string(),
  paletteName: z.string(),
  colors: z.array(z.string()),
  brandCode: BrandCodeSchema,
  paletteFullPublicId: z.string().optional(),
  palettePublicName: z.string().optional(),
});

export type PaletteOutputType = z.infer<typeof PaletteOutputSchema>;

export const SharePaletteInputSchema = z.object({
  palettePublicName: z.string(),
  userPublicName: z.string().optional(),
  setUserPublicName: z.boolean(),
});

export type SharePaletteInputType = z.infer<typeof SharePaletteInputSchema>;

export const PostSharePaletteInputSchema = z.object({
  json: z.string().transform((data) => {
    try {
      return SharePaletteInputSchema.parse(JSON.parse(data));
    } catch (e) {
      throw new Error("Invalid JSON structure");
    }
  }),
  image: z.any().refine((file) => file instanceof Blob, { message: "Invalid file format" }),
});

export const SharedPaletteOutputSchema = z.object({
  paletteFullPublicId: z.string(),
  palettePublicName: z.string(),
  userPublicId: z.string(),
  userPublicName: z.string(),
  userNameChanged: z.boolean(),
});

export type SharedPaletteOutputType = z.infer<typeof SharedPaletteOutputSchema>;
